/**
 *
 * ShareButton
 *
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import { DhlLink } from "@dhl-official/react-library";
import { Variants } from "@dhl-official/stencil-library";
import { injectIntl } from "react-intl";
import { IntlPropType, trackContentInteraction } from "root/libs/core-libs/src";

const COPY_ID_PREFIX = "ShareButton";

const ShareButton = injectIntl(
  ({
    intl,
    trackEvent,
    trackingValue,
    dataTestid,
    dataTracking,
    shareUrl,
    utfDataObject,
  }) => {
    const [clickedButton, setClickedButton] = useState(false);

    const createMailtoLink = (_shareUrl) => {
      return `mailto:?subject=${encodeURIComponent(
        intl.formatMessage({ id: `${COPY_ID_PREFIX}.mailSubject` })
      )}&body=${encodeURIComponent(
        intl.formatMessage(
          { id: `${COPY_ID_PREFIX}.mailSubject` },
          { nl: "\n" }
        )
      )}%0D%0A%0D%0A${_shareUrl}`;
    };

    const onClick = () => {
      setClickedButton(true);
      trackEvent(trackingValue);
      trackContentInteraction(utfDataObject);
    };

    const mailtoLink = createMailtoLink(encodeURIComponent(shareUrl));

    return (
      <div>
        <DhlLink
          isFullWidth
          variant={Variants.outline}
          href={mailtoLink}
          dataTestid={dataTestid}
          clickEvent={onClick}
          clickedButton={clickedButton}
          dataTracking={dataTracking}
          target="_blank"
        >
          {intl.formatMessage({ id: `${COPY_ID_PREFIX}.label` })}
        </DhlLink>
      </div>
    );
  }
);

ShareButton.propTypes = {
  intl: IntlPropType.isRequired,
  dataTestid: PropTypes.string,
  dataTracking: PropTypes.string,
  trackEvent: PropTypes.func,
  trackingValue: PropTypes.object,
  shareUrl: PropTypes.string.isRequired,
  fallBackDataTracking: PropTypes.string,
  fallBackTrackingValue: PropTypes.object,
  utfDataObject: PropTypes.object,
};

ShareButton.defaultProps = {
  dataTestid: undefined,
  dataTracking: "",
  trackEvent: () => {},
  trackingValue: {},
  fallBackDataTracking: "",
  fallBackTrackingValue: {},
  utfDataObject: {},
};

export default ShareButton;
